<template>
  <div class="not-found-page">
    <div class="not-found-container">
      <svg
        class="error-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p class="error-message">The page you're looking for doesn't exist.</p>
      <div class="actions">
        <button @click="goHome" class="home-button">Go Home</button>
        <button @click="goBack" class="back-button">Go Back</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

function goHome() {
  window.location.href = '/edits';
}

function goBack() {
  router.back();
}
</script>

<style scoped>
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(to bottom, var(--color-bg-primary), var(--color-bg-secondary));
  padding: 2rem;
}

.not-found-container {
  background: transparent;
  border-radius: 0;
  padding: 0;
  max-width: 500px;
  width: 100%;
  box-shadow: none;
  text-align: center;
  margin-top: -32px;
}

.error-icon {
  width: 80px;
  height: 80px;
  color: #fc8181;
  margin: 0 auto 1.5rem;
}

h1 {
  font-size: 4rem;
  font-weight: 800;
  color: var(--color-accent);
  margin: 0 0 0.5rem;
  line-height: 1;
}

h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 1rem;
}

.error-message {
  color: #4a5568;
  font-size: 1rem;
  margin: 0 0 2rem;
  line-height: 1.5;
}

.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.home-button,
.back-button {
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.home-button {
  color: white;
  background: var(--color-accent);
}

.home-button:hover {
  background: var(--color-accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(97, 174, 212, 0.3);
}

.back-button {
  color: #4a5568;
  background: #e2e8f0;
}

.back-button:hover {
  background: #cbd5e0;
  transform: translateY(-1px);
}
</style>
